import React from 'react';
import { useSelector } from 'react-redux';
import { i18n } from 'utils/i18n';
import { loadingRedirect } from 'utils/redirect';
import { analyticsInteraction, analyticsPrepareKey } from 'utils/analytics';
import ANALYTICS from 'constants/analytics';
import WINDOW_OBJECT_KEYS from 'constants/windowObjectKeys';
import MODAL, { MODAL_THEMES, MODAL_BUTTON_TYPES } from 'constants/modals';
import Modal from 'components/Modal';
import { ModalFooter } from 'components/Modal/ModalFooter';
import { isCustomPathReservationSelector } from 'selectors/customPathCheckInSelectors';

const { ACCEPT, DECLINE } = MODAL_BUTTON_TYPES;

/**
 * STCIneligibleModal - Modal shown to the user trying to start Skip The Counter
 * flow with a ineligible Reservation.
 * @return {JSX}
 */
const STCIneligibleModal = () => {
  const isCustomPathReservation = useSelector(isCustomPathReservationSelector);

  return (
    <Modal modalKey={MODAL.STC_INELIGIBLE_MODAL} theme={MODAL_THEMES.WHITE} header={i18n('ineligible_modal_title')}>
      {() => (
        <>
          <p
            id={`${MODAL.STC_INELIGIBLE_MODAL}_desc`}
            className='modal-themed__paragraph modal-themed__paragraph--center-align'
          >
            {i18n('stc_ineligible_modal_copy')}
          </p>

          <ModalFooter
            fullWidthButton
            buttons={[
              {
                type: DECLINE,
                label: i18n('common_close'),
              },
              {
                type: ACCEPT,
                label: i18n('common_view_details'),
                handler: () =>
                  loadingRedirect(
                    isCustomPathReservation
                      ? WINDOW_OBJECT_KEYS.CUSTOM_PATH_RENTAL_DETAILS
                      : WINDOW_OBJECT_KEYS.RENTAL_DETAILS
                  ),
                analyticsHandler: () =>
                  analyticsInteraction(
                    ANALYTICS.MODAL,
                    analyticsPrepareKey(MODAL.STC_INELIGIBLE_MODAL),
                    ANALYTICS.VIEW_DETAILS
                  ),
              },
            ]}
          />
        </>
      )}
    </Modal>
  );
};

export default STCIneligibleModal;
